(function(){
  var rules = {
    'edc-pocket-knives': function(text, type){
      return type === 'edc & pocket knives' &&
        !/(fixed blade|full tang|knife set|kitchen|pill|capsule|bottle|lighter|utensil|scissors|shears|utility knife|shooting target|ammo|axe|hatchet|tomahawk)/.test(text);
    },
    'fixed-blade-knives': function(text, type){
      var match = type === 'fixed blade knives' || /(fixed blade|full tang|bushcraft|bowie|machete|skinning)/.test(text);
      return match && !/(kitchen|chef|sharpener|whetstone)/.test(text) && type !== 'kitchen knives' && type !== 'sharpening';
    },
    'kitchen-knives': function(text, type){
      var match = type === 'kitchen knives' || /(kitchen|chef|cutlery|paring|cleaver|butcher|bread knife|knife set|scissors|shears)/.test(text);
      return match && !/(whetstone|sharpening stone|ferro|fire starter|fixed blade|full tang|bushcraft|camping knife|camping knives|hunting|survival|outdoor knife|edc knife|kydex sheath|leather sheath)/.test(text) && (!/sharpener/.test(text) || /knife set/.test(text));
    },
    'multi-tools': function(text, type){
      var match = type === 'multi-tools' || /(multi tool|multi-tool|multitool|pliers)/.test(text);
      return match && !/(flashlight|headlamp|head lamp|lighter|trekking pole|axe|fixed blade|full tang)/.test(text);
    },
    'axes-tools': function(text, type){
      return type === 'axes & tools' || /(axe|hatchet|tomahawk|hammer|machete|saw|chainsaw)/.test(text);
    },
    'sharpening': function(text, type){
      var match = type === 'sharpening' || /(sharpener|sharpening|whetstone|honing|grit)/.test(text);
      return match && !/(knife set|kitchen chef|chef's knives|chef knives)/.test(text);
    },
    'accessories': function(text, type){
      var accessoryMatch = type === 'accessories' || /(pill|capsule|bottle|headlamp|head lamp|flashlight|work light|ferro|fire starter|lighter|target|ammo|lock box|chainsaw chain|trekking pole|fishing hook|cookware|utensil|knife holder|knife block)/.test(text);
      var knifeMatch = /(fixed blade|full tang|bushcraft|camping knives|camping knife|hunting knife|skinning knife|blade with|knife with|chef knife|cleaver|paring knife)/.test(text);
      return accessoryMatch && (!knifeMatch || /(pill|capsule|bottle|knife holder|knife block|chainsaw chain|target|ammo|headlamp|flashlight|lighter)/.test(text));
    },
    'outdoor-camping': function(text, type){
      var match = type === 'outdoor & camping' || type === 'fixed blade knives' || type === 'axes & tools' || /(outdoor|camping|hiking|bushcraft|survival|hunting|fishing|axe)/.test(text);
      return match && !/(pill|capsule|kitchen|chef|whetstone|sharpener|shooting target|target paper|ammo|gel ammo|water bullet|bb gun|pellet gun|pistol shooting)/.test(text);
    }
  };

  function category(){
    var path = window.location.pathname;
    var keys = ['edc-pocket-knives', 'outdoor-camping', 'fixed-blade-knives', 'kitchen-knives', 'multi-tools', 'axes-tools', 'sharpening', 'accessories'];
    for (var i = 0; i < keys.length; i += 1) {
      if (path.indexOf('/' + keys[i]) !== -1) return keys[i];
    }
    return '';
  }

  function normalize(value){
    return (value || '').toString().replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function run(){
    var key = category();
    if (!key || !rules[key] || !window.jQuery) return;
    window.jQuery('.tt-product').each(function(){
      var card = window.jQuery(this);
      var title = normalize(card.find('.tt-title').text());
      var type = normalize(card.find('.tt-add-info li').eq(1).text());
      var text = title + ' ' + type;
      card.attr('data-km-category-checked', key);
      card.closest('.tt-col-item, .element-item').toggle(rules[key](text, type));
    });
  }

  function boot(){
    run();
    var count = 0;
    var timer = setInterval(function(){
      run();
      count += 1;
      if (count >= 12) clearInterval(timer);
    }, 1000);
    if (window.MutationObserver) {
      var listing = document.querySelector('.tt-product-listing');
      if (listing) new MutationObserver(run).observe(listing, {childList: true, subtree: true});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
